/**
 * Логика слайдера постов и радио плеера (Swiper.js через npm)
 */

import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', function() {
    // Мобильный слайдер
    const mobileSlider = new Swiper('.hh-post-slider-mobile', {
        modules: [Navigation, Pagination],
        slidesPerView: 1,
        loop: false,
        navigation: {
            nextEl: '.hh-slider-arrow-mobile-next',
            prevEl: '.hh-slider-arrow-mobile-prev',
        },
        pagination: {
            el: '.hh-slider-pagination-mobile',
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="' + className + ' hh-slider-dot"></span>';
            },
        },
    });

    // Десктопный слайдер
    const desktopSlider = new Swiper('.hh-post-slider-desktop', {
        modules: [Navigation, Pagination],
        slidesPerView: 1,
        loop: false,
        navigation: {
            nextEl: '.hh-slider-arrow-desktop-next',
            prevEl: '.hh-slider-arrow-desktop-prev',
        },
        pagination: {
            el: '.hh-slider-pagination-desktop',
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="' + className + ' hh-slider-dot"></span>';
            },
        },
    });

    // Загрузка расписания
    if (typeof scheduleApiUrl !== 'undefined') {
        fetch(scheduleApiUrl)
            .then(response => response.json())
            .then(data => {
                const now = new Date();
                const currentTime = now.getHours() * 60 + now.getMinutes();

                let prevProgram = null;
                let currentProgram = null;
                let nextPrograms = [];

                data.forEach(program => {
                    const [hours, minutes] = program.time.split(':');
                    const programTime = parseInt(hours) * 60 + parseInt(minutes);

                    if (programTime <= currentTime) {
                        prevProgram = currentProgram;
                        currentProgram = program;
                    } else if (nextPrograms.length < 2) {
                        nextPrograms.push(program);
                    }
                });

                if (currentProgram) {
                    const currentEl = document.getElementById('current-program');
                    if (currentEl) currentEl.textContent = currentProgram.program_name;
                }

                if (prevProgram) {
                    const prevEl = document.getElementById('prev-program');
                    if (prevEl) {
                        prevEl.innerHTML = `
                            <p class="font-normal">${prevProgram.program_name}</p>
                            <p class="text-xs">${prevProgram.time.substring(0, 5)}</p>
                        `;
                    }
                }

                if (nextPrograms.length > 0) {
                    const nextEl = document.getElementById('next-programs');
                    if (nextEl) {
                        nextEl.innerHTML = nextPrograms.map(p => `
                            <div class="hh-schedule-item">
                                <p class="font-normal">${p.program_name}</p>
                                <p class="text-xs">${p.time.substring(0, 5)}</p>
                            </div>
                        `).join('');
                    }
                }

                const currentMobile = document.getElementById('current-program-mobile');
                if (currentMobile && currentProgram) {
                    currentMobile.textContent = currentProgram.program_name;
                }

                const prevMobile = document.getElementById('prev-program-mobile');
                if (prevMobile && prevProgram) {
                    prevMobile.innerHTML = `
                        <p class="font-normal">${prevProgram.program_name}</p>
                        <p class="text-xs">${prevProgram.time.substring(0, 5)}</p>
                    `;
                }

                const nextMobile = document.getElementById('next-programs-mobile');
                if (nextMobile && nextPrograms.length > 0) {
                    nextMobile.innerHTML = nextPrograms.map(p => `
                        <div class="hh-schedule-item">
                            <p class="font-normal">${p.program_name}</p>
                            <p class="text-xs">${p.time.substring(0, 5)}</p>
                        </div>
                    `).join('');
                }
            })
            .catch(error => {
                console.error('Ошибка загрузки расписания:', error);
            });
    }
});